(function($) {
    class EventsCalendar {
        constructor() {
            this.wp_query = window._mgw_wp_query;
            this.el = $('.js-postsloader');

            if (Object.prototype.toString.call(window._mgw_state) === '[object Array]') {
                this.state = {};
            } else {
                this.state = window._mgw_state;
            }

            if (! this.el) return;

            this.filtersState = [];
            this.xhr = null;

            this.ui = {
                form: this.el.find('.js-postsloader-form'),
                submitBtn: this.el.find('button.forms__button'),
                container: this.el.find('.ajaxContainer'),
                badges: this.el.find('.filtersState__badges'),
                pagination: $('.js-pagination'),
                resetBtn: this.el.find('.filtersState__reset'),
                subfiltersContianer: this.el.find('.eventslist_datetype'),
                subfilters: this.el.find('.subfilter'),
                eventslist_day: this.el.find('input[name="eventslist_day"]'),
                eventslist_range_1: this.el.find('input[name="eventslist_range_1"]'),
                eventslist_range_2: this.el.find('input[name="eventslist_range_2"]'),
                range1: $('#cal_range1'),
                range2: $('#cal_range2')
            }

            this.calendar = null;

            this.uistate = {
                loading: false,
                fromPopstate: false,
                range1: null,
                range2: null
            }

            this.init();
        }



        initCalendar() {
            const self = this;
            const cal = $('#cal');

            if (! cal) return;

            let w = $('.filtersPanel').width();

            this.calendar = cal.calendar({
                width: w,
                height: w,
                format: 'yyyy-mm-dd',
                // filteredRang: ['2020-03-20', '2020-03-26'],
                selectedRang: [new Date()],
                data: window._mgw_calendar_data,
                cellpadding: 4,
                onSelected: function (view, date, value) {
                    date = self.dateToYMD(date);
                    self.ui.eventslist_day.val(date);
                    self.state.eventslist_day = date;
                },
            });

            this.ui.range1.calendar({
                width: w,
                height: w,
                format: 'yyyy-mm-dd',
                // filteredRang: ['2020-03-01', '2020-03-10'],
                // selectedRang: [new Date()],
                data: window._mgw_calendar_data,
                cellpadding: 4,
                onSelected: function (view, date, value) {
                    self.setDateRange(date, null);
                },
            });
            this.ui.range2.calendar({
                width: w,
                height: w,
                format: 'yyyy-mm-dd',
                // filteredRang: ['2020-03-01', '2020-03-10'],
                // selectedRang: [new Date()],
                data: window._mgw_calendar_data,
                cellpadding: 4,
                onSelected: function (view, date, value) {
                    self.setDateRange(null, date);
                },
            });

            $('#test').on('click', function() {
                self.ui.range1.calendar('setDate', '2020-05-12');
            });

            let debounced = _.debounce(function() {
                console.log(window.isloading);
                if (window.isloading) return;
                let w = $('.filtersPanel').width();
                console.log(w);
                cal.calendar('dynamicResize', w);
                self.ui.range1.calendar('dynamicResize', w);
                self.ui.range2.calendar('dynamicResize', w);
            }, 500);
            
            $(window).on('resize', debounced);
        }

        subfilters() {
            const self = this;
            this.ui.subfiltersContianer.on('change', 'input[name="eventslist_datetype"]', function() {
                let me = $(this);
                // console.log(me.val());
                self.ui.subfilters.stop().slideUp();
                self.ui.subfilters.filter('.type_' + me.val()).stop().slideDown();
            });
        }

        setDateRange(date_obj1, date_obj2) {
            const self = this;
            console.log(this.uistate.range1);
            console.log(this.uistate.range2);
            let date1 = null;
            let date2 = null;

            if (date_obj1) {
                console.log('date1');
                date1 = this.dateToYMD(date_obj1);
                // this.ui.eventslist_day.val(date);
                this.uistate.range1 = date1;
                this.state.eventslist_range1 = date1;

                console.log(this.uistate.range1);
                console.log(this.uistate.range2);

                this.ui.range2.calendar('setSelectedRang', [date1, null]);

                if (this.uistate.range2 && this.uistate.range1 > this.uistate.range2) {
                    console.log('BAD');
                    this.uistate.range2 = this.uistate.range1;
                }
            }
            if (date_obj2) {
                console.log('date2');
                date2 = this.dateToYMD(date_obj2);
                // this.ui.eventslist_day.val(date);
                this.uistate.range2 = date2;
                this.state.eventslist_range2 = date2;
                this.ui.range1.calendar('setSelectedRang', [null, date2]);

                if (this.uistate.range1 && this.uistate.range1 > this.uistate.range2) {
                    console.log('BAD2');
                    this.uistate.range1 = this.uistate.range2;
                    this.ui.range2.calendar('setSelectedRang', [this.uistate.range1, null]);
                }
            }

            if (this.uistate.range1 && this.uistate.range2) {
                console.log('TU1');
                // self.ui.range1.calendar('setDate', this.uistate.range1);
                // self.ui.range2.calendar('setDate', this.uistate.range2);

                self.ui.range1.calendar('setRange', [this.uistate.range1, this.uistate.range2, 0]);
                self.ui.range2.calendar('setRange', [this.uistate.range1, this.uistate.range2, 1]);

                this.ui.eventslist_range_1.val(this.uistate.range1);
                this.ui.eventslist_range_2.val(this.uistate.range2);
            }
        }

        dateToYMD(date) {
            var d = date.getDate();
            var m = date.getMonth() + 1; //Month from 0 to 11
            var y = date.getFullYear();
            return '' + y + '-' + (m<=9 ? '0' + m : m) + '-' + (d <= 9 ? '0' + d : d);
        }

        setInitialState() {
            var now = new Date();
            var $today = this.dateToYMD(now);
            
            if (this.state.eventslist_day) {
                this.calendar.calendar('setDate', this.state.eventslist_day);
            } else {
                this.calendar.calendar('setDate', $today);
                this.ui.eventslist_day.val($today);
            }

            if (this.state.eventslist_range_1 && this.state.eventslist_range_2) {
                
                if (this.state.eventslist_range_1 > this.state.eventslist_range_2) {
                    var url = window.location.href.split('?')[0];
                    window.location.href = url;
                }

                this.uistate.range1 = this.state.eventslist_range_1;
                this.uistate.range2 = this.state.eventslist_range_2;
                this.ui.range1.calendar('setDate', this.state.eventslist_range_1);
                this.ui.range2.calendar('setDate', this.state.eventslist_range_2);
                this.ui.range1.calendar('setRange', [this.state.eventslist_range_1, this.state.eventslist_range_2, 0]);
                this.ui.range2.calendar('setRange', [this.state.eventslist_range_1, this.state.eventslist_range_2, 1]);
                this.ui.eventslist_range_1.val(this.state.eventslist_range_1);
                this.ui.eventslist_range_2.val(this.state.eventslist_range_2);
            } else {
                this.uistate.range1 = $today;
                this.uistate.range2 = $today;
                this.ui.range1.calendar('setDate', $today);
                this.ui.range2.calendar('setDate', $today);
                this.ui.range1.calendar('setRange', [$today, $today, 0]);
                this.ui.range2.calendar('setRange', [$today, $today, 1]);
                this.ui.eventslist_range_1.val($today);
                this.ui.eventslist_range_2.val($today);
            }

        }

        init() {
            // this.initFiltersState();
            // this.events();
            // this.selectrics();
            this.initCalendar();
            this.subfilters();
            this.setInitialState();

            // console.log(this.state);
            // window.addEventListener('popstate', this.handlePopstate.bind(this));
        }
    }

    if (window._mgw_is_calendar) {
        new EventsCalendar();
    }

})(jQuery)